import React from "react";
import AchievementCard1 from "./AchievementCard1";
// import ResultCard1 from "./AchievementCard1";
// import kanak from "../../../images/IMG_0249.JPG"
import nur1 from "../../../images/achievementimage/nur1.jpeg"
import nur2 from "../../../images/achievementimage/nur2.jpeg"
import nur3 from "../../../images/achievementimage/nur3.jpeg"
import lkg1 from "../../../images/achievementimage/lkg1.jpeg"
import lkg2 from "../../../images/achievementimage/lkg2.jpeg"
import lkg3 from "../../../images/achievementimage/lkg3.jpeg"
import ukg2 from "../../../images/achievementimage/ukg2.jpeg"
import ukg3 from "../../../images/achievementimage/ukg3.jpeg"
const AchievementCard = (props) => {
  if (props.page === 1) {
    if (props.row === "top") {
      return (
        <div className="max-w-7xl lg:flex lg:mx-auto lg:w-[100%] ">
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - P.G"
            name=" 2022-23"
            title=" POSITION - 1"
            para="2022-23"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - P.G"
            name="2022-23"
            title="POSITION - 2"
            para="ALBERT "
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard="CLASS - P.G"
            name="2022-23"
            title="POSITION - 3"
            para="GREEK"
          />
        </div>
      );
    } else {
      return (
        <div className="max-w-7xl lg:flex lg:mx-auto">
          <AchievementCard1
            image={nur1}
            standard=" CLASS - NURSERY"
            name="2022-23"
            title="POSITION - 1"
            para="PRANUSHA , AADHYA , SHAKSHI , PIYUSH , VIRAT "
          />
          <AchievementCard1
            image={nur2}
            standard="CLASS -  NURSERY"
            name="2022-23"
            title="POSITION - 2"
            para="UMAIRA"
          />
          <AchievementCard1
            image={nur3}
            standard="CLASS -  NURSERY"
            name="2022-23"
            title="POSITION - 3"
            para="RISHU , PRIYA , MANSHI"
          />
        </div>
      );
    }
  }

  if (props.page === 2) {
    if (props.row === "top") {
      return (
        <div className="max-w-7xl lg:flex lg:mx-auto">
          <AchievementCard1
            // image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkilpPaZPIX6QIcB5CVW5V67v-h5zgYa4u6iDiEyMtmnLecBFsX4CgEYLwO3cetMKXErs&usqp=CAU"
            image={lkg1}
            standard="CLASS -  L.K.G"
            name="2022-23"
            title="POSITION - 1"
            para="DIVYANSHI , VANSH SONI"
          />
          <AchievementCard1
            image={lkg2}
            standard="CLASS -  L.K.G"
            name="2022-23"
            title="POSITION - 2"
            para="ANANYA , INAYA NAAZ  "
          />
          <AchievementCard1
            image={lkg3}
            standard="CLASS -  L.K.G"
            name="2022-23"
            title="POSITION - 3"
            para="ALOK GOUTOM , AARYA KATARA , PIHU TITTAL"
          />
        </div>
      );
    } else {
      return (
        <div className="max-w-7xl lg:flex lg:mx-auto">
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard="CLASS -  U.K.G"
            name="2022-23"
            title="POSITION - 1"
            para="SIYA , NAITIK"
          />
          <AchievementCard1
            image={ukg2}
            standard="CLASS -  U.K.G"
            name="2022-23"
            title="POSITION - 2"
            para="SHAURYA , USHMEET"
          />
          <AchievementCard1
            image={ukg3}
            standard="CLASS -  U.K.G"
            name="2022-23"
            title="POSITION - 3"
            para="UPRAMIT"
          />
        </div>
      );
    }
  }

  if (props.page === 3) {
    if (props.row === "top") {
      return (
        <div className="max-w-7xl lg:flex lg:mx-auto">
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard="CLASS - I"
            name="2022-23"
            title="POSITION - 1"
            para="TWINKLE LALWANI"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard="CLASS - I"
            name="2022-23"
            title="POSITION - 2"
            para="TANMAY CHODHARY"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - I"
            name="2022-23"
            title="POSITION - 3"
            para="TEJAS"
          />
        </div>
      );
    } else {
      return (
        <div className="max-w-7xl lg:flex lg:mx-auto">
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - II "
            name="2022-23"
            title="POSITION - 1"
            para="ABHISHEK"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard="  CLASS - II"
            name="2022-23"
            title="POSITION - 2"
            para="PARI SHARMA"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard="  CLASS - II"
            name="2022-23"
            title="POSITION - 3"
            para="DIMPLE KHYANI"
          />
        </div>
      );
    }
  }

  if (props.page === 4) {
    if (props.row === "top") {
      return (
        <div className="max-w-7xl lg:flex lg:mx-auto">
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - III"
            name="2022-23"
            title="POSITION - 1"
            para="HARSHADA"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - III"
            name="2022-23"
            title="POSITION - 2"
            para="MAHI LALWANI"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - III"
            name="2022-23"
            title="POSITION - 3"
            para="ARPITA SHARMA"
          />
        </div>
      );
    } else {
      return (
        <div className="max-w-7xl lg:flex lg:mx-auto">
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - IV"
            name="2022-23"
            title="POSITION - 1"
            para="YASHASVI"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - IV"
            name="2022-23"
            title="POSITION - 2"
            para="BHAVESH"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - IV"
            name="2022-23"
            title="POSITION - 3"
            para="SHREYA"
          />
        </div>
      );
    }
  }

  if (props.page === 5) {
    if (props.row === "top") {
      return (
        <div className="max-w-7xl lg:flex lg:mx-auto">
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - V"
            name="2022-23"
            title="POSITION - 1"
            para="ADITI SURYAVASHI"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard="  CLASS - V"
            name="2022-23"
            title="POSITION - 2"
            para="HARINAKSHI BAGHEL"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard="  CLASS - V"
            name="2022-23"
            title="POSITION - 3"
            para="SARTHAK SIKARWAR"
          />
        </div>
      );
    } else {
      return (
        <div className="max-w-7xl lg:flex lg:mx-auto">
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - VI"
            name="2022-23"
            title="POSITION - 1"
            para="GYATI JAIN"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - VI"
            name="2022-23"
            title="POSITION - 2"
            para="ANSHI JAIN"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - VI"
            name="2022-23"
            title="POSITION - 3"
            para="NANDANI AGARWAL"
          />
        </div>
      );
    }
  }

  if (props.page === 6) {
    if (props.row === "top") {
      return (
        <div className="max-w-7xl lg:flex lg:mx-auto">
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - VII"
            name="2022-23"
            title="POSITION - 1"
            para="KHUSHBOO YADAV"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - VII"
            name="2022-23"
            title="POSITION - 2"
            para="SANIKA SURYAVANSHI"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - VII"
            name="2022-23"
            title="POSITION - 3"
            para="PRACHI PANJWANI"
          />
        </div>
      );
    } else {
      return (
        <div className="max-w-7xl lg:flex lg:mx-auto">
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard=" CLASS - VIII"
            name="2022-23"
            title="POSITION - 1"
            para="JANVI KHAN"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard="  CLASS - VIII"
            name="2022-23"
            title="POSITION - 2"
            para="HARSHIT SONI"
          />
          <AchievementCard1
            image="https://a0.anyrgb.com/pngimg/1888/1342/college-cartoon-college-students-student-college-student-college-students-man-avatars-avatar-user-avatar-man-avatar-estudante.png"
            standard="  CLASS - VIII"
            name="2022-23"
            title="POSITION - 3"
            para="SHRADDHA"
          />
        </div>
      );
    }
  }
};
export default AchievementCard;
